module.exports = __webpack_public_path__ + "media/images/p-about/about/project-bd2dcc8733632db2779f50ffd87cf2df.svg";